import { SaveOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Empty,
  Form,
  Input,
  InputNumber,
  List,
  message,
  Modal,
  Row,
  Select,
  Spin,
  Tabs,
  Typography
} from 'antd';
import isEqual from 'lodash/isEqual';
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { SubSubtitleStart, Subtitle } from '../../components';
import CurrencyInputCustom from '../../components/CurrencyInputCustom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { currencyToNumber, errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';

const { Option } = Select;
const { TabPane } = Tabs;
// const { RangePicker } = CustomDatePicker;
// const dateFormat = 'DD/MM/YYYY';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 }
  }
};

const formDialogLayout = {
  labelCol: {
    xs: { span: 8 }
  },
  wrapperCol: {
    xs: { span: 16 }
  }
};

const getLabel = (field) => {
  switch (field) {
    case 'aseguradora':
      return 'Aseguradora';
    case 'vigencia':
      return 'Vigencia';
    case 'pagos_codigo':
      return 'Comercio';
    case 'sebaot_tiene':
      return 'Tiene Sebaot';
    case 'sebaot_host':
      return 'Host';
    case 'sebaot_puerto':
      return 'Puerto';
    case 'sebaot_user':
      return 'Usuario';
    case 'sebaot_pass':
      return 'Contraseña';
    case 'sebaot_host_pagos':
      return 'Host';
    case 'sebaot_puerto_pagos':
      return 'Puerto';
    case 'sebaot_user_pagos':
      return 'Usuario';
    case 'sebaot_pass_pagos':
      return 'Contraseña';
    case 'sebaot_user_pagos_lote':
      return 'Usuario';
    case 'sebaot_pass_pagos_lote':
      return 'Contraseña';
    case 'sebaot_agente':
      return 'Código de agente';
    case 'sebaot_cobrador':
      return 'Código de cobrador';
    case 'codigo_procesadora':
      return 'Código de procesadora';
    case 'producto_segu':
      return 'Producto de Segu360';
    case 'producto':
      return 'Producto';
    case 'objeto':
      return 'Objeto';
    case 'riesgo':
      return 'Riesgo';
    case 'tipo_riesgo':
      return 'Tipo Riesgo';
    case 'monto_cumulo_personales_gs':
      return 'Cúmulo Personales (Gs.)';
    case 'monto_cumulo_personales_usd':
      return 'Cúmulo Personales (USD.)';
    case 'monto_cumulo_patrimoniales_gs':
      return 'Cúmulo Patrimoniales (Gs.)';
    case 'monto_cumulo_patrimoniales_usd':
      return 'Cúmulo Patrimoniales (USD.)';
    case 'monto_cumulo_vehiculos_gs':
      return 'Cúmulo Vehículos (Gs.)';
    case 'monto_cumulo_vehiculos_usd':
      return 'Cúmulo Vehículos (USD.)';
    default:
      return field;
  }
};

const ConexionSebaot = ({ config, ...props }) => {
  const [probando, setProbando] = useState();
  const [conexionForm] = Form.useForm();
  const { open, initialValues } = config;
  const listaSebaot = useCallback(
    async (
      resource,
      {
        aseguradoraId,
        hostSebaot,
        puertoSebaot,
        userSebaot,
        passSebaot,
        hostSebaotPagos,
        puertoSebaotPagos,
        userSebaotPagos,
        passSebaotPagos,
        userSebaotPagosLote,
        passSebaotPagosLote
      }
    ) => {
      return instanceRef.instance.get(`/sebaot/${resource}`, {
        params: {
          aseguradoraId,
          hostSebaot,
          puertoSebaot,
          userSebaot,
          passSebaot,
          hostSebaotPagos,
          puertoSebaotPagos,
          userSebaotPagos,
          passSebaotPagos,
          userSebaotPagosLote,
          passSebaotPagosLote
        }
      });
    },
    []
  );

  const onFinish = async (values) => {
    try {
      setProbando(true);
      const params = {
        aseguradoraId: config.aseguradoraId,
        hostSebaot: values.sebaot_host,
        puertoSebaot: values.sebaot_puerto,
        userSebaot: values.sebaot_user,
        passSebaot: values.sebaot_pass,
        hostSebaotPagos: values.sebaot_host_pagos,
        puertoSebaotPagos: values.sebaot_puerto_pagos,
        userSebaotPagos: values.sebaot_user_pagos,
        passSebaotPagos: values.sebaot_pass_pagos,
        userSebaotPagosLote: values.sebaot_user_pagos_lote,
        passSebaotPagosLote: values.sebaot_pass_pagos_lote
      };
      const response = await listaSebaot('check', params);
      if (response.data.data) {
        message.info('Configurado correctamente');
        conexionForm.resetFields();
        props.onFinish(values);
      } else {
        message.error('Verificar parámetros de Sebaot');
      }
    } catch (err) {
      errorHandler(err, 'Verificar parámetros de Sebaot');
    }
    setProbando(false);
  };

  useEffect(() => {
    if (conexionForm && open) {
      conexionForm.resetFields();
    }
  }, [conexionForm, open]);

  return (
    <Modal
      title="Configurar acceso a Sebaot"
      open={open}
      okButtonProps={{ loading: probando }}
      onCancel={() => {
        conexionForm.resetFields();
        props.onCancel();
      }}
      footer={[
        config.desactivar ? (
          <Button
            key="link"
            type="dashed"
            disabled={probando}
            onClick={props.onDisable}
          >
            Desactivar
          </Button>
        ) : null,
        <Button
          key="back"
          disabled={probando}
          onClick={() => {
            conexionForm.resetFields();
            props.onCancel();
          }}
        >
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={probando}
          onClick={() => {
            conexionForm.validateFields().then(onFinish);
          }}
        >
          Aceptar
        </Button>
      ]}
    >
      <div style={{ textAlign: 'left' }}>
        <>
          <Form
            {...formDialogLayout}
            initialValues={initialValues}
            scrollToFirstError
            form={conexionForm}
            name="accesoSebaot"
            autoComplete="off"
            layout="horizontal"
          >
            <Typography.Title level={5} style={{ textAlign: 'center' }}>
              Servicio Web
            </Typography.Title>
            <Form.Item
              label={getLabel('sebaot_host')}
              rules={[
                {
                  required: true,
                  whitespace: true
                }
              ]}
              name="sebaot_host"
            >
              <Input placeholder="https://example.com" />
            </Form.Item>
            <Form.Item
              label={getLabel('sebaot_puerto')}
              rules={[
                {
                  required: true
                }
              ]}
              name="sebaot_puerto"
            >
              <InputNumber placeholder="8080" />
            </Form.Item>
            <Form.Item
              label={getLabel('sebaot_user')}
              rules={[
                {
                  required: true,
                  whitespace: true
                }
              ]}
              name="sebaot_user"
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={getLabel('sebaot_pass')}
              rules={[
                {
                  required: true,
                  whitespace: true
                }
              ]}
              name="sebaot_pass"
            >
              <Input.Password autoComplete="new-password" />
            </Form.Item>
            <Typography.Title level={5} style={{ textAlign: 'center' }}>
              Acceso Web
            </Typography.Title>
            <Form.Item
              label={getLabel('sebaot_user_pagos_lote')}
              rules={[
                {
                  required: true,
                  whitespace: true
                }
              ]}
              name="sebaot_user_pagos_lote"
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={getLabel('sebaot_pass_pagos_lote')}
              rules={[
                {
                  required: true,
                  whitespace: true
                }
              ]}
              name="sebaot_pass_pagos_lote"
            >
              <Input.Password autoComplete="new-password" />
            </Form.Item>
            <Typography.Title level={5} style={{ textAlign: 'center' }}>
              Cobros
            </Typography.Title>
            <Form.Item
              label={getLabel('sebaot_host_pagos')}
              rules={[
                {
                  required: true,
                  whitespace: true
                }
              ]}
              name="sebaot_host_pagos"
            >
              <Input placeholder="https://example.com" />
            </Form.Item>
            <Form.Item
              label={getLabel('sebaot_puerto_pagos')}
              rules={[
                {
                  required: true
                }
              ]}
              name="sebaot_puerto_pagos"
            >
              <InputNumber placeholder="8080" />
            </Form.Item>
            <Form.Item
              label={getLabel('sebaot_user_pagos')}
              rules={[
                {
                  required: true,
                  whitespace: true
                }
              ]}
              name="sebaot_user_pagos"
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={getLabel('sebaot_pass_pagos')}
              rules={[
                {
                  required: true,
                  whitespace: true
                }
              ]}
              name="sebaot_pass_pagos"
            >
              <Input.Password autoComplete="new-password" />
            </Form.Item>
          </Form>
        </>
      </div>
    </Modal>
  );
};

const AdminAseguradoraForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [configurando, setConfigurando] = useState(false);
  const [model, setModel] = useState();
  const [productos, setProductos] = useState([]);
  const [agentes, setAgentes] = useState([]);
  const [cobradores, setCobradores] = useState([]);
  const [productosModificados, setProductosModificados] = useState([]);
  const [datosConexionModificados, setDatosConexionModificados] = useState([]);
  const [aseguradoraProductosCodigo, setAseguradoraProductosCodigo] = useState(
    []
  );
  const [comercios, setComercios] = useState([]);
  const [tieneSebaot, setTieneSebaot] = useState(false);
  const [tieneSebaotOriginal, setTieneSebaotOriginal] = useState(false);
  const [riesgos, setRiesgos] = useState([]);
  const [objetos, setObjetos] = useState([]);
  const [tiposRiesgo, setTiposRiesgo] = useState([]);
  const [visible, setVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('1');
  const [config, setConfig] = useState({ open: false });
  const [datosConexion, setDatosConexion] = useState({});
  const [datosConexionOriginal, setDatosConexionOriginal] = useState({});
  const [productosSegu, setProductosSegu] = useState([]);
  const {
    params: { id: idAseguradora }
  } = useRouteMatch();

  const monedaGs = { codigo: 'gs', simbolo: 'Gs.' };
  const monedaUsd = { codigo: 'usd', simbolo: 'USD.' };

  const onFinish = async () => {
    let valuesToCompare = {};
    const values = form.getFieldValue();
    const valuesSinAseguradora = {
      ...values,
      ...datosConexion,
      sebaot_tiene: tieneSebaot
    };
    delete valuesSinAseguradora.aseguradora;
    Object.entries(valuesSinAseguradora).forEach(([key]) => {
      valuesToCompare[key] = model[key];
    });

    if (!valuesSinAseguradora.pagos_codigo) {
      valuesSinAseguradora.pagos_codigo = null;
    }
    // valuesSinAseguradora.productos =
    //   values.productos || aseguradoraProductosCodigo;
    valuesToCompare = {
      ...valuesToCompare,
      productos: aseguradoraProductosCodigo,
      ...datosConexionOriginal,
      sebaot_tiene: tieneSebaotOriginal
    };
    if (valuesSinAseguradora.productos) {
      valuesToCompare.productos = aseguradoraProductosCodigo.map((item) => {
        const nuevos = { ...item };
        delete nuevos.id;
        return nuevos;
      });
    }
    try {
      if (!isEqual(valuesSinAseguradora, valuesToCompare)) {
        actualizarProductosModificados(valuesSinAseguradora, valuesToCompare);
        actualizarDatosConexionModificados(
          { ...datosConexionOriginal, sebaot_tiene: tieneSebaotOriginal },
          {
            ...datosConexion,
            sebaot_tiene: tieneSebaot
          }
        );
        setVisible(true);
      } else {
        message.warning('No hay datos modificados');
      }
    } catch (error2) {
      errorHandler(error2);
    }
  };

  const actualizarDatosConexionModificados = (original, nuevos) => {
    const modificados = [];
    Object.keys(original).forEach((key) => {
      if (`${original[key]}` !== `${nuevos[key]}`) {
        modificados.push({
          label: getLabel(key),
          antes: getValue(original[key]),
          ahora: getValue(nuevos[key])
        });
      }
    });
    setDatosConexionModificados(modificados);
  };
  const actualizarProductosModificados = (
    valuesSinAseguradora,
    valuesToCompare
  ) => {
    Object.entries(valuesSinAseguradora).forEach(([key]) => {
      if (key === 'productos') {
        const productosModificadosAux = [];
        valuesSinAseguradora[key].forEach((item, index) => {
          const camposModificados = {};
          if (item.producto !== valuesToCompare[key][index].producto) {
            camposModificados.producto = {
              label: `${productosSegu[index].producto.descripcion} (${getLabel(
                'producto'
              )})`,
              antes:
                productos.find(
                  (prod) =>
                    `${prod.codigo}-${prod.codigo_seccion}` ===
                    valuesToCompare[key][index].producto
                )?.descripcion || '',
              ahora:
                productos.find(
                  (prod) =>
                    `${prod.codigo}-${prod.codigo_seccion}` === item.producto
                )?.descripcion || ''
            };
          }
          if (item.objeto !== valuesToCompare[key][index].objeto) {
            camposModificados.objeto = {
              label: `${productosSegu[index].producto.descripcion} (${getLabel(
                'objeto'
              )})`,
              antes:
                objetos.find(
                  (prod) =>
                    `${prod.codigo}` === valuesToCompare[key][index].objeto
                )?.descripcion || '',
              ahora:
                objetos.find((prod) => `${prod.codigo}` === item.objeto)
                  ?.descripcion || ''
            };
          }
          if (item.riesgo !== valuesToCompare[key][index].riesgo) {
            camposModificados.riesgo = {
              label: `${productosSegu[index].producto.descripcion} (${getLabel(
                'riesgo'
              )})`,
              antes:
                riesgos.find(
                  (prod) =>
                    `${prod.codigo}` === valuesToCompare[key][index].riesgo
                )?.descripcion || '',
              ahora:
                riesgos.find((prod) => `${prod.codigo}` === item.riesgo)
                  ?.descripcion || ''
            };
          }

          if (item.tipo_riesgo !== valuesToCompare[key][index].tipo_riesgo) {
            camposModificados.tipo_riesgo = {
              label: `${productosSegu[index].producto.descripcion} (${getLabel(
                'tipo_riesgo'
              )})`,
              antes:
                tiposRiesgo.find(
                  (prod) =>
                    `${prod.codigo}` === valuesToCompare[key][index].tipo_riesgo
                )?.descripcion || '',
              ahora:
                tiposRiesgo.find(
                  (prod) => `${prod.codigo}` === item.tipo_riesgo
                )?.descripcion || ''
            };
          }

          if (Object.keys(camposModificados).length > 0) {
            productosModificadosAux.push(camposModificados);
          }
        });
        setProductosModificados(productosModificadosAux);
      }
    });
  };

  const update = async () => {
    try {
      setLoading(true);
      const datos = {
        ...form.getFieldsValue(),
        sebaot_tiene: tieneSebaot,
        ...datosConexion
      };
      if (datos.monto_cumulo_personales_gs) {
        datos.monto_cumulo_personales_gs = currencyToNumber(
          datos.monto_cumulo_personales_gs,
          monedaGs
        );
      }
      if (datos.monto_cumulo_personales_usd) {
        datos.monto_cumulo_personales_usd = currencyToNumber(
          datos.monto_cumulo_personales_usd,
          monedaUsd
        );
      }
      if (datos.monto_cumulo_patrimoniales_gs) {
        datos.monto_cumulo_patrimoniales_gs = currencyToNumber(
          datos.monto_cumulo_patrimoniales_gs,
          monedaGs
        );
      }
      if (datos.monto_cumulo_patrimoniales_usd) {
        datos.monto_cumulo_patrimoniales_usd = currencyToNumber(
          datos.monto_cumulo_patrimoniales_usd,
          monedaUsd
        );
      }
      if (datos.monto_cumulo_vehiculos_gs) {
        datos.monto_cumulo_vehiculos_gs = currencyToNumber(
          datos.monto_cumulo_vehiculos_gs,
          monedaGs
        );
      }
      if (datos.monto_cumulo_vehiculos_usd) {
        datos.monto_cumulo_vehiculos_usd = currencyToNumber(
          datos.monto_cumulo_vehiculos_usd,
          monedaUsd
        );
      }

      delete datos.aseguradora;
      datos.productos = datos.productos?.map((producto, index) => ({
        idAseguradoraProducto: aseguradoraProductosCodigo[index].id,
        sebaot_codigo_producto: producto.producto?.split('-')[0] || null,
        sebaot_codigo_seccion: producto.producto?.split('-')[1] || null,
        sebaot_objeto: producto.objeto || null,
        sebaot_riesgo: producto.riesgo || null,
        sebaot_tipo_riesgo: producto.tipo_riesgo || null
      }));
      if (!datos.pagos_codigo) {
        datos.pagos_codigo = null;
      }
      await instanceRef.instance.put(`aseguradoras/${idAseguradora}`, datos);
      message.success('Aseguradora actualizada correctamente');
      // await loadAseguradora(idAseguradora);
      form.resetFields();
      setProductosModificados([]);
      setDatosConexionModificados([]);
      loadAseguradora(idAseguradora);
    } catch (error2) {
      errorHandler(error2);
    }
    setLoading(false);
  };

  const loadAseguradora = async (id) => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.get(`/aseguradoras/${id}`);
      setLoading(false);
      if (response.data?.data) {
        const {
          sebaot_tiene,
          sebaot_host,
          sebaot_puerto,
          sebaot_user,
          sebaot_pass,
          sebaot_host_pagos,
          sebaot_puerto_pagos,
          sebaot_user_pagos,
          sebaot_pass_pagos,
          sebaot_user_pagos_lote,
          sebaot_pass_pagos_lote,
          sebaot_agente,
          sebaot_cobrador,
          pagos_codigo,
          codigo_procesadora,
          monto_cumulo_personales_gs,
          monto_cumulo_personales_usd,
          monto_cumulo_patrimoniales_gs,
          monto_cumulo_patrimoniales_usd,
          monto_cumulo_vehiculos_gs,
          monto_cumulo_vehiculos_usd
          // aseguradoraEmpresa: { sebaot_codigo_agente, fecha_inicio, fecha_fin }
        } = response.data.data;
        const originalModel = {
          sebaot_agente,
          sebaot_cobrador,
          pagos_codigo,
          codigo_procesadora,
          monto_cumulo_personales_gs,
          monto_cumulo_personales_usd,
          monto_cumulo_patrimoniales_gs,
          monto_cumulo_patrimoniales_usd,
          monto_cumulo_vehiculos_gs,
          monto_cumulo_vehiculos_usd
          // aseguradoraEmpresa: {
          //   fecha_inicio: moment(fecha_inicio),
          //   fecha_fin: moment(fecha_fin)
          // }
        };
        form.setFieldsValue(originalModel);
        setModel(originalModel);
        setDatosConexionOriginal({
          sebaot_host,
          sebaot_puerto,
          sebaot_user,
          sebaot_pass,
          sebaot_host_pagos,
          sebaot_puerto_pagos,
          sebaot_user_pagos,
          sebaot_pass_pagos,
          sebaot_user_pagos_lote,
          sebaot_pass_pagos_lote
        });
        setDatosConexion({
          sebaot_host,
          sebaot_puerto,
          sebaot_user,
          sebaot_pass,
          sebaot_host_pagos,
          sebaot_puerto_pagos,
          sebaot_user_pagos,
          sebaot_pass_pagos,
          sebaot_user_pagos_lote,
          sebaot_pass_pagos_lote
        });
        if (sebaot_tiene) {
          setTieneSebaot(true);
          setTieneSebaotOriginal(true);
          loadSebaotData({
            hostSebaot: sebaot_host,
            puertoSebaot: sebaot_puerto,
            userSebaot: sebaot_user,
            passSebaot: sebaot_pass,
            hostSebaotPagos: sebaot_host_pagos,
            puertoSebaotPagos: sebaot_puerto_pagos,
            userSebaotPagos: sebaot_user_pagos,
            passSebaotPagos: sebaot_pass_pagos,
            userSebaotPagosLote: sebaot_user_pagos_lote,
            passSebaotPagosLote: sebaot_pass_pagos_lote
          });
        }
      }
    } catch (error2) {
      errorHandler(error2);
    }
    setLoading(false);
  };

  const handleOk = () => {
    setVisible(false);
    update();
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleOkConfigurar = async ({
    hostSebaot,
    puertoSebaot,
    userSebaot,
    passSebaot,
    hostSebaotPagos,
    puertoSebaotPagos,
    userSebaotPagos,
    passSebaotPagos,
    userSebaotPagosLote,
    passSebaotPagosLote
  }) => {
    const loaded = await loadSebaotData({
      hostSebaot,
      puertoSebaot,
      userSebaot,
      passSebaot,
      hostSebaotPagos,
      puertoSebaotPagos,
      userSebaotPagos,
      passSebaotPagos,
      userSebaotPagosLote,
      passSebaotPagosLote
    });
    return loaded;
  };

  const getValue = (value, key) => {
    if (value === undefined) {
      return '';
    }
    if (value === null) {
      return '';
    }
    if (value === true) {
      return 'Si';
    }
    if (value === false) {
      return 'No';
    }
    if (key === 'monto_cumulo_personales_gs') {
      return currencyToNumber(value, monedaGs);
    }
    if (key === 'monto_cumulo_personales_usd') {
      return currencyToNumber(value, monedaUsd);
    }
    if (key === 'monto_cumulo_patrimoniales_gs') {
      return currencyToNumber(value, monedaGs);
    }
    if (key === 'monto_cumulo_patrimoniales_usd') {
      return currencyToNumber(value, monedaUsd);
    }
    if (key === 'monto_cumulo_vehiculos_gs') {
      return currencyToNumber(value, monedaGs);
    }
    if (key === 'monto_cumulo_vehiculos_usd') {
      return currencyToNumber(value, monedaUsd);
    }
    return value;
  };

  const fetchListSebaot = useCallback(
    async (
      resource,
      {
        hostSebaot,
        puertoSebaot,
        userSebaot,
        passSebaot,
        hostSebaotPagos,
        puertoSebaotPagos,
        userSebaotPagos,
        passSebaotPagos,
        userSebaotPagosLote,
        passSebaotPagosLote
      }
    ) => {
      return instanceRef.instance.get(`/sebaot/${resource}`, {
        params: {
          hostSebaot,
          puertoSebaot,
          userSebaot,
          passSebaot,
          hostSebaotPagos,
          puertoSebaotPagos,
          userSebaotPagos,
          passSebaotPagos,
          userSebaotPagosLote,
          passSebaotPagosLote,
          idAseguradora
        }
      });
    },
    [idAseguradora]
  );

  const loadSebaotData = async (params) => {
    try {
      setConfigurando(true);
      const responseProductos = await fetchListSebaot('consultarDatos', {
        ...params,
        idAseguradora
      });
      if (responseProductos.data.data.productos) {
        setProductos(responseProductos.data.data.productos);
        setAgentes(responseProductos.data.data.agentes);
        setCobradores(responseProductos.data.data.cobradores);
        setObjetos(responseProductos.data.data.objetos);
        setRiesgos(responseProductos.data.data.riesgos);
        setTiposRiesgo(responseProductos.data.data.tiposRiesgo);
        setProductosSegu(responseProductos.data.data.productosSegu);
        const productosOrdenados = responseProductos.data.data.productosSegu;

        const newProductos = {
          productos: productosOrdenados.map((item) => {
            const prod = {};
            if (item.sebaot_codigo_producto) {
              prod.producto = `${item.sebaot_codigo_producto}-${item.sebaot_codigo_seccion}`;
            } else {
              prod.producto = undefined;
            }
            prod.objeto = item.sebaot_objeto && `${item.sebaot_objeto}`;
            prod.riesgo = item.sebaot_riesgo && `${item.sebaot_riesgo}`;
            prod.tipo_riesgo =
              item.sebaot_tipo_riesgo && `${item.sebaot_tipo_riesgo}`;
            return prod;
          })
        };
        form.setFieldsValue(newProductos);
        setAseguradoraProductosCodigo(
          newProductos.productos.map((item, index) => ({
            ...item,
            id: productosOrdenados[index].id
          }))
        );
        setConfigurando(false);
        return true;
      }
      message.error('Verificar parámetros de Sebaot');
    } catch (error) {
      message.error('Verificar parámetros de Sebaot');
    }
    setConfigurando(false);
    return false;
  };

  const onFinishConexionSebaot = async (datos) => {
    setConfig({ open: false });
    setTieneSebaot(true);
    const loaded = await handleOkConfigurar({
      hostSebaot: datos.sebaot_host,
      puertoSebaot: datos.sebaot_puerto,
      userSebaot: datos.sebaot_user,
      passSebaot: datos.sebaot_pass,
      hostSebaotPagos: datos.sebaot_host_pagos,
      puertoSebaotPagos: datos.sebaot_puerto_pagos,
      userSebaotPagos: datos.sebaot_user_pagos,
      passSebaotPagos: datos.sebaot_pass_pagos,
      userSebaotPagosLote: datos.sebaot_user_pagos_lote,
      passSebaotPagosLote: datos.sebaot_pass_pagos_lote
    });
    if (loaded) {
      setDatosConexion({
        ...datos,
        sebaot_puerto: `${datos.sebaot_puerto}`,
        sebaot_puerto_pagos: `${datos.sebaot_puerto_pagos}`
      });
    }
  };

  const onCancelConexionSebaot = () => {
    setConfig({ open: false });
  };

  const onDisableConexionSebaot = async () => {
    setTieneSebaot(false);
    setConfig({ open: false });
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      const response = await instanceRef.instance.get('pagos/comercio');
      setComercios(response.data.data || []);
      setLoading(false);
    };
    loadData();
  }, []);

  useEffect(() => {
    if (idAseguradora) {
      loadAseguradora(idAseguradora);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idAseguradora]);

  return (
    <ResponsiveContainer size="large">
      <Card title="Configuración de parámetros" style={{ textAlign: 'left' }}>
        <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
          <div>
            <ConexionSebaot
              config={config}
              onFinish={onFinishConexionSebaot}
              onCancel={onCancelConexionSebaot}
              onDisable={onDisableConexionSebaot}
            />
            <Form
              {...formItemLayout}
              initialValues={{}}
              scrollToFirstError
              form={form}
              name="aseguradoras"
              autoComplete="off"
              layout="vertical"
              onFinish={onFinish}
            >
              <>
                <Tabs
                  defaultActiveKey="1"
                  size="large"
                  onChange={setActiveTab}
                  tabBarExtraContent={
                    activeTab === '2' &&
                    tieneSebaot && (
                      <Button
                        onClick={() => {
                          setConfig({
                            open: true,
                            initialValues: datosConexion,
                            desactivar: tieneSebaot,
                            aseguradoraId: idAseguradora
                          });
                        }}
                      >
                        Configurar
                      </Button>
                    )
                  }
                >
                  <TabPane tab="Aseguradora" key="1">
                    <Row gutter={16}>
                      <Col md={12} xs={24}>
                        <SubSubtitleStart>
                          Cúmulo para Personales
                        </SubSubtitleStart>
                        <Form.Item name="monto_cumulo_personales_gs">
                          <CurrencyInputCustom
                            moneda={monedaGs}
                            bordered
                            style={{ height: 35.14 }}
                          />
                        </Form.Item>
                        <Form.Item name="monto_cumulo_personales_usd">
                          <CurrencyInputCustom
                            moneda={monedaUsd}
                            bordered
                            style={{ height: 35.14 }}
                          />
                        </Form.Item>
                      </Col>
                      <Col md={12} xs={24}>
                        <SubSubtitleStart>
                          Cúmulo para Patrimoniales
                        </SubSubtitleStart>
                        <Form.Item name="monto_cumulo_patrimoniales_gs">
                          <CurrencyInputCustom
                            moneda={monedaGs}
                            bordered
                            style={{ height: 35.14 }}
                          />
                        </Form.Item>
                        <Form.Item name="monto_cumulo_patrimoniales_usd">
                          <CurrencyInputCustom
                            moneda={monedaUsd}
                            bordered
                            style={{ height: 35.14 }}
                          />
                        </Form.Item>
                      </Col>
                      <Col md={12} xs={24}>
                        <SubSubtitleStart>
                          Cúmulo para Vehículos
                        </SubSubtitleStart>
                        <Form.Item name="monto_cumulo_vehiculos_gs">
                          <CurrencyInputCustom
                            moneda={monedaGs}
                            bordered
                            style={{ height: 35.14 }}
                          />
                        </Form.Item>
                        <Form.Item name="monto_cumulo_vehiculos_usd">
                          <CurrencyInputCustom
                            moneda={monedaUsd}
                            bordered
                            style={{ height: 35.14 }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tab="Sebaot" key="2">
                    <Spin spinning={configurando}>
                      {!tieneSebaot && !loading && (
                        <Empty
                          image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                          imageStyle={{
                            height: 60
                          }}
                          description={
                            <span>
                              No se ha configurado la conexión con Sebaot
                            </span>
                          }
                        >
                          <Button
                            type="primary"
                            onClick={() =>
                              setConfig({
                                open: true,
                                initialValues: datosConexion,
                                aseguradoraId: idAseguradora
                              })
                            }
                          >
                            Configurar
                          </Button>
                        </Empty>
                      )}
                      {tieneSebaot && (
                        <div>
                          <br />
                          <Row gutter={16}>
                            <Col md={12} xs={24}>
                              <Form.Item
                                label={getLabel('sebaot_agente')}
                                rules={[
                                  {
                                    whitespace: true
                                  }
                                ]}
                                name="sebaot_agente"
                              >
                                <Select
                                  showSearch
                                  allowClear
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                  style={{ width: '100%' }}
                                  optionFilterProp="children"
                                  placeholder="Seleccionar Agente"
                                >
                                  {agentes.map((item) => (
                                    <Option
                                      key={`${item.codigo}`}
                                      value={`${item.codigo}`}
                                    >
                                      {`${item.codigo} - ${item.nombre} - Matrícula (${item.matricula})`}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col md={12} xs={24}>
                              <Form.Item
                                label={getLabel('sebaot_cobrador')}
                                rules={[
                                  {
                                    whitespace: true
                                  }
                                ]}
                                name="sebaot_cobrador"
                              >
                                <Select
                                  showSearch
                                  allowClear
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                  style={{ width: '100%' }}
                                  optionFilterProp="children"
                                  placeholder="Seleccionar Agente"
                                >
                                  {cobradores.map((item) => (
                                    <Option
                                      key={`${item.codigo}`}
                                      value={`${item.codigo}`}
                                    >
                                      {`${item.codigo} - ${item.nombre}`}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                          </Row>
                          <Subtitle>Coberturas</Subtitle>
                          {productosSegu.length > 0 && (
                            <Form.List name="productos">
                              {(fields) => (
                                <List
                                  grid={{
                                    gutter: 16,
                                    xs: 1,
                                    sm: 2,
                                    md: 2,
                                    lg: 3,
                                    xl: 3,
                                    xxl: 3
                                  }}
                                  dataSource={productosSegu}
                                  renderItem={(item, index) => {
                                    if (fields[index]) {
                                      return (
                                        <List.Item>
                                          <Card
                                            title={item.producto.descripcion}
                                            size="small"
                                            type="inner"
                                          >
                                            <Form.Item
                                              label={getLabel('producto')}
                                              name={[
                                                fields[index].key,
                                                'producto'
                                              ]}
                                            >
                                              <Select
                                                showSearch
                                                allowClear
                                                filterOption={(input, option) =>
                                                  option.children
                                                    .toLowerCase()
                                                    .indexOf(
                                                      input.toLowerCase()
                                                    ) >= 0
                                                }
                                                style={{ width: '100%' }}
                                                optionFilterProp="children"
                                                placeholder="Seleccionar Producto de Sebaot"
                                              >
                                                {productos.map(
                                                  (itemProducto) => (
                                                    <Option
                                                      key={`${itemProducto.codigo}-${itemProducto.codigo_seccion}`}
                                                      value={`${itemProducto.codigo}-${itemProducto.codigo_seccion}`}
                                                    >
                                                      {`${itemProducto.codigo} - ${itemProducto.codigo_seccion} - ${itemProducto.descripcion}`}
                                                    </Option>
                                                  )
                                                )}
                                              </Select>
                                            </Form.Item>
                                            <Form.Item
                                              label={getLabel('Objeto')}
                                              name={[
                                                fields[index].key,
                                                'objeto'
                                              ]}
                                            >
                                              <Select
                                                showSearch
                                                allowClear
                                                filterOption={(input, option) =>
                                                  option.children
                                                    .toLowerCase()
                                                    .indexOf(
                                                      input.toLowerCase()
                                                    ) >= 0
                                                }
                                                style={{ width: '100%' }}
                                                optionFilterProp="children"
                                                placeholder="Seleccionar Riesgo de Sebaot"
                                              >
                                                {objetos.map((itemRiesgo) => (
                                                  <Option
                                                    key={itemRiesgo.codigo}
                                                    value={`${itemRiesgo.codigo}`}
                                                  >
                                                    {`${itemRiesgo.codigo} - ${itemRiesgo.descripcion}`}
                                                  </Option>
                                                ))}
                                              </Select>
                                            </Form.Item>

                                            <Form.Item
                                              label={getLabel('Riesgo')}
                                              name={[
                                                fields[index].key,
                                                'riesgo'
                                              ]}
                                            >
                                              <Select
                                                showSearch
                                                allowClear
                                                filterOption={(input, option) =>
                                                  option.children
                                                    .toLowerCase()
                                                    .indexOf(
                                                      input.toLowerCase()
                                                    ) >= 0
                                                }
                                                style={{ width: '100%' }}
                                                optionFilterProp="children"
                                                placeholder="Seleccionar Riesgo de Sebaot"
                                              >
                                                {riesgos.map((itemRiesgo) => (
                                                  <Option
                                                    key={itemRiesgo.codigo}
                                                    value={`${itemRiesgo.codigo}`}
                                                  >
                                                    {`${itemRiesgo.codigo} - ${itemRiesgo.descripcion}`}
                                                  </Option>
                                                ))}
                                              </Select>
                                            </Form.Item>
                                            <Form.Item
                                              label={getLabel('tipo_riesgo')}
                                              name={[
                                                fields[index].key,
                                                'tipo_riesgo'
                                              ]}
                                            >
                                              <Select
                                                showSearch
                                                allowClear
                                                filterOption={(input, option) =>
                                                  option.children
                                                    .toLowerCase()
                                                    .indexOf(
                                                      input.toLowerCase()
                                                    ) >= 0
                                                }
                                                style={{ width: '100%' }}
                                                optionFilterProp="children"
                                                placeholder="Seleccionar Tipo de Riesgo"
                                              >
                                                {tiposRiesgo.map((itemTipo) => (
                                                  <Option
                                                    key={itemTipo.codigo}
                                                    value={`${itemTipo.codigo}`}
                                                  >
                                                    {`${itemTipo.codigo} - ${itemTipo.descripcion}`}
                                                  </Option>
                                                ))}
                                              </Select>
                                            </Form.Item>
                                          </Card>
                                        </List.Item>
                                      );
                                    }
                                    return null;
                                  }}
                                />
                              )}
                            </Form.List>
                          )}
                        </div>
                      )}
                    </Spin>
                  </TabPane>
                  <TabPane tab="Pagos360" key="3">
                    <Form.Item
                      label={getLabel('pagos_codigo')}
                      name="pagos_codigo"
                    >
                      <Select
                        showSearch
                        allowClear
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        style={{ width: '100%' }}
                        optionFilterProp="children"
                        placeholder="Seleccionar Comercio"
                      >
                        {comercios.map((comercio) => (
                          <Option
                            key={`${comercio.id}`}
                            value={`${comercio.id}`}
                          >
                            {`${comercio.name}`}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </TabPane>
                </Tabs>
              </>
              <br />
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || configurando}
                icon={<SaveOutlined />}
              >
                Actualizar
              </Button>
            </Form>
          </div>
        </Spin>
      </Card>
      <Modal
        title="Los datos fueron editados. ¿Está seguro de querer guardarlos?"
        width={1000}
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <>
          <Row>
            <Col span={8} align="start" />
            <Col span={8} align="start">
              <strong>Antes</strong>
            </Col>
            <Col span={8} align="start">
              <strong>Ahora</strong>
            </Col>
            {model &&
              Object.keys(model).map((key) => {
                if (key === 'productos') {
                  return null;
                }

                if (form.getFieldValue(key) !== model[key]) {
                  if (key === 'pagos_codigo') {
                    let nombreComercio = '';
                    if (model[key]) {
                      const comercio = comercios.find(
                        (com) => com.id === Number(model[key])
                      );
                      nombreComercio = comercio?.name || '-';
                    }

                    let nombreComercioNuevo = '';
                    if (form.getFieldValue(key)) {
                      const comercio = comercios.find(
                        (com) => com.id === Number(form.getFieldValue(key))
                      );
                      nombreComercioNuevo = comercio?.name || '-';
                    }

                    return (
                      <Fragment key={key}>
                        <Col span={8} align="start">
                          <p>{`${getLabel(key)}`}</p>
                        </Col>
                        <Col span={8} align="start">
                          {`${nombreComercio}`}
                        </Col>
                        <Col span={8} align="start">
                          <strong>{`${nombreComercioNuevo}`}</strong>
                        </Col>
                      </Fragment>
                    );
                  }
                  return (
                    <Fragment key={key}>
                      <Col span={8} align="start">
                        <p>{`${getLabel(key)}`}</p>
                      </Col>
                      <Col span={8} align="start">
                        {`${getValue(model[key])}`}
                      </Col>
                      <Col span={8} align="start">
                        <strong>{`${getValue(
                          form.getFieldValue(key)
                        )}`}</strong>
                      </Col>
                    </Fragment>
                  );
                }
                return null;
              })}
            {productosModificados.length > 0 &&
              productosModificados.map((item) => {
                return Object.keys(item).map((key) => (
                  <Fragment key={key}>
                    <Col span={8} align="start">
                      <p>{`${item[key].label}`}</p>
                    </Col>
                    <Col span={8} align="start">
                      {`${item[key].antes}`}
                    </Col>
                    <Col span={8} align="start">
                      <strong>{`${item[key].ahora}`}</strong>
                    </Col>
                  </Fragment>
                ));
              })}
            {datosConexionModificados.length > 0 &&
              datosConexionModificados.map((item) => {
                return (
                  <Fragment key={item.label}>
                    <Col span={8} align="start">
                      <p>{`${item.label}`}</p>
                    </Col>
                    <Col span={8} align="start">
                      {`${item.antes}`}
                    </Col>
                    <Col span={8} align="start">
                      <strong>{`${item.ahora}`}</strong>
                    </Col>
                  </Fragment>
                );
              })}
          </Row>
        </>
      </Modal>
    </ResponsiveContainer>
  );
};

export default AdminAseguradoraForm;
